import {
  LayoutServiceData,
  HTMLLink,
  Field,
  getChildPlaceholder,
  ComponentRendering,
} from "@sitecore-jss/sitecore-jss-nextjs";
import Placeholder from "@repo/sitecore-lib/Placeholder";
import {
  ChatbotContextProvider,
  FAQLayout,
  VersionNumber,
} from "@repo/sitecore-lib/topshop-sitecore-components";
import BaseLayout from "./base-layout";
import styles from "./layout.module.css";

interface HelpLayoutProps {
  layoutData: LayoutServiceData;
  headLinks: HTMLLink[];
}

const HelpLayout = ({
  layoutData,
  headLinks,
}: HelpLayoutProps): JSX.Element => {
  const { route } = layoutData.sitecore;
  const { placeholders, fields } = route || {};

  const childComponents = getChildPlaceholder(
    route as unknown as ComponentRendering,
    "headless-main",
  );

  const hasAside = childComponents?.some(
    (component) =>
      "placeholders" in component &&
      component.placeholders &&
      Object.keys(component.placeholders).some((key) => key.includes("aside")),
  );

  return (
    <ChatbotContextProvider>
      <BaseLayout layoutData={layoutData} headLinks={headLinks}>
        {route &&
          (hasAside ? (
            <FAQLayout rendering={route as unknown as ComponentRendering} />
          ) : (
            placeholders && (
              <>
                {"headless-header" in placeholders ? (
                  <header className={styles.header}>
                    <Placeholder
                      name="headless-header"
                      rendering={route}
                      classname="heroPlaceholder"
                    />
                  </header>
                ) : null}
                <Placeholder
                  name="headless-main"
                  rendering={route}
                  classname="mainPlaceholder"
                />
              </>
            )
          ))}
        {fields?.versionNumber && fields.lastUpdated && (
          <VersionNumber
            lastUpdated={fields.lastUpdated as Field<string>}
            versionNumber={fields.versionNumber as Field<string>}
          />
        )}
      </BaseLayout>
    </ChatbotContextProvider>
  );
};

export default HelpLayout;
